<template>
	<div>
		<el-dialog
			:center="true"
			:visible.sync="show"
			:close-on-click-modal="false"
			top="2vh"
			width="80vw"
			class="studentDialogueDataDialog"
		>
			<div class="a-d-top">
				<div class="a-d-topTit">
					<div>{{ lang.dialogue_content }}</div>
				</div>
				<div class="a-d-t-right">
					<span @click="close()">×</span>
				</div>
			</div>
			<div class="sddd_box" v-loading="loading">
				<!-- <span v-html="value"></span> -->
				<template v-for="item in messageList">
					<div :key="item.uid">
						<div class="na_m_item" v-if="item.userContent">
							<div class="na_m_i_name">
								{{ item.userName }}
							</div>
							<div class="na_m_i_content" v-html="item.userContent"></div>
						</div>
						<div class="na_m_item" v-if="item.aiContent">
							<div class="na_m_i_name aiName">
								{{ item.aiName }}
							</div>
							<div class="na_m_i_content" v-html="item.aiContent"></div>
						</div>
					</div>
				</template>
			</div>
			<div class="sddd_bottom">
				<el-button type="primary" @click="close()">{{
					lang.queding
				}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loading: false,
			show: false,
			data: null,
			messageList: [],
		};
	},
	computed: {},
	methods: {
		open(data) {
			this.data = data;
			let _messageList = JSON.parse(JSON.stringify(data.messageList));
			this.messageList = _messageList;
			this.loading = false;
			this.show = true;
		},
		close() {
			this.show = false;
			this.init();
		},
		init() {
			this.data = null;
			this.loading = false;
			this.messageList = [];
		},
	},
};
</script>

<style scoped>
.studentDialogueDataDialog >>> .el-dialog {
	min-width: 80vw;

	height: auto;
	/* height: 780px; */
	box-shadow: 0px 0 8px 0px #555555;
	border-radius: 8px;
	background-color: #fff;
	/* top: 0px; */
	/* margin: 0 auto; */
	overflow: hidden;
}
.studentDialogueDataDialog >>> .el-dialog__body {
	height: 100%;
	min-width: 80vw;
	flex-shrink: 0;
	box-sizing: border-box;
	padding-bottom: 20px;
	padding-top: 10px;
	overflow: auto;
}
.studentDialogueDataDialog >>> .el-dialog__header {
	display: none !important;
}

.a-d-top {
	/* background: #adadad; */
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	align-items: center;
	justify-content: space-between;
	height: 54px;
	border-radius: 8px 8px 0 0;
	user-select: none;
	border-bottom: 1px #ccc solid;
}
.a-d-top >>> .el-input__inner {
	width: 320px;
	height: 32px;
}
.a-d-top >>> .el-input__icon {
	line-height: 32px;
}

.a-d-topTit {
	/* width: 171px; */
	/* margin-left: 20px; */
	height: 32px;
	display: flex;
	font-weight: bold;
	font-size: 20px;
	align-items: center;
	font-family: PingFang SC;
	box-sizing: border-box;
	padding: 5px;
	line-height: 22px;
	justify-content: center;
	/* text-align: left; */
}

.a-d-t-right > span {
	font-size: 18px;
	font-weight: bold;
	cursor: pointer;
}

.sddd_box {
	width: 100%;
	height: 80vh;
	overflow: auto;
	background-color: #f4f4f4;
	box-sizing: border-box;
	padding: 20px;
}

.sddd_bottom {
	display: flex;
	margin-top: 20px;
	justify-content: flex-end;
}

.sddd_box {
	width: 100%;
	height: 80vh;
	overflow: auto;
}

.na_m_item {
	width: 100%;
	height: auto;
	margin: 10px 0;
}

.na_m_i_name {
	width: fit-content;
	max-width: 100%;
	height: auto;
	box-sizing: border-box;
	padding: 10px 10px;
	display: flex;
	align-items: center;
	border-radius: 10px 10px 0 0;
	background-color: #9747ff;
	color: #fff;
	text-overflow: ellipsis;
	overflow: hidden;
	white-space: nowrap;
}
.aiName {
	background-color: #0560fc;
}
.na_m_i_content {
	padding: 10px;
	border: solid 1px #e7e7e7;
	box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
	border-radius: 0 0 12px 12px;
}

.na_m_i_content :deep(p img) {
  max-width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}
</style>
